import React, { useState } from 'react';
import { BASE_URL } from '../../components/AppConfig';
import { useDispatch } from 'react-redux';
import { handleDynamicRequest } from '../../components/DyanamicRequest';
import { setUserId, setUserRole, setUserName, setJwtToken, setU_photo, setPermissions, setIsSuperAdmin, setIsCreatedByAdmin } from '../../Store/Role/action';
import NavBar from '../../components/NavBar/NavBar';
import { useNavigate } from 'react-router-dom';
import { storeSessionToken } from '../../utils/authToken';


function Login() {
  const [alertMessage, setAlertMessage] = useState({ success: '', error: '' });
  const [loginMode, setLoginMode] = useState('admin'); // 'admin' or 'user'
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  }
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  }

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setAlertMessage({ success: '', error: '' });

    const isUserLogin = loginMode === 'user';
    const requestBody = isUserLogin
      ? { username: username.trim(), password }
      : { email, password };

    const method = 'POST';
    const url = isUserLogin ? `${BASE_URL}/admin/user-login` : `${BASE_URL}/admin/login`;

    const wrongResponse = () => {
      setAlertMessage({ success: '', error: 'Wrong Credentials' });
    };

    const rightResponse = (data) => {
      if (data) {
        const sessionToken = data.data?.token;
        if (sessionToken) {
          const sessionExpiration = new Date().getTime() + 5000 * 60 * 5000;
          storeSessionToken(sessionToken);
          sessionStorage.setItem('sessionExpiration', sessionExpiration);
        }
        dispatch(setUserId(data.data.admin.id));
        dispatch(setUserRole(data.data.admin.role_id));
        dispatch(setUserName(data.data.admin.name))
        dispatch(setPermissions(data.data.admin.permissions));
        dispatch(setIsSuperAdmin(data.data.admin.superAdmin));
        dispatch(setIsCreatedByAdmin(data.data.admin.isCreatedByAdmin || false));
      }
    };

    const authenticated = await handleDynamicRequest(method, url, requestBody, wrongResponse, rightResponse);

    if (authenticated) {
      window.location = '/';
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleResetPasswordRedirect = () => {
    navigate('/reset-password');
  };

  return (
    <section>
      <NavBar login={{ status: true }} />
      <div className="container-fluid p-0">
        <div className="row">
          <div className="col-12">
            <div className="login-card">
              <form className="theme-form login-form" onSubmit={handleEmailSubmit}>
                <h4>Login</h4>
                <h6>Welcome back! Log in to your account.</h6>

                <div className="form-group">
                  <div className="d-flex gap-2 mb-3">
                    <button
                      type="button"
                      className={`btn ${loginMode === 'admin' ? 'btn-primary' : 'btn-outline-primary'} flex-fill`}
                      onClick={() => setLoginMode('admin')}
                    >
                      Admin
                    </button>
                    <button
                      type="button"
                      className={`btn ${loginMode === 'user' ? 'btn-primary' : 'btn-outline-primary'} flex-fill`}
                      onClick={() => setLoginMode('user')}
                    >
                      User
                    </button>
                  </div>
                </div>

                {loginMode === 'admin' ? (
                  <div className="form-group">
                    <label>Email Address</label>
                    <div className="input-group">
                      <span className="input-group-text"><i className="icon-email"></i></span>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Test@gmail.com"
                        value={email}
                        onChange={handleEmailChange}
                        required
                      />
                    </div>
                  </div>
                ) : (
                  <div className="form-group">
                    <label>Username</label>
                    <div className="input-group">
                      <span className="input-group-text"><i className="icon-user"></i></span>
                      <input
                        className="form-control"
                        type="text"
                        name="username"
                        placeholder="Enter username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                )}

                <div className="form-group">
                  <label>Password</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="icon-lock"></i></span>
                    <input
                      className="form-control"
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      placeholder="*********"
                      value={password}
                      onChange={handlePasswordChange}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? 'Hide' : 'Show'}
                    </button>
                  </div>
                </div>
                <div className="form-group">
                  <div className="checkbox">
                    <input id="checkbox1" type="checkbox" />
                    <label className="text-muted" htmlFor="checkbox1">Remember password</label>
                  </div>
                </div>
                <div className="form-group">
                  <button className="btn btn-primary btn-block" type="submit">Sign in</button>
                </div>
                {loginMode === 'admin' && (
                  <div className="form-group text-center">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={handleResetPasswordRedirect}
                    >
                      Reset Password
                    </button>
                  </div>
                )}
              </form>
              {alertMessage.error && <div className="alert alert-danger">{alertMessage.error}</div>}
              {alertMessage.success && <div className="alert alert-success">{alertMessage.success}</div>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
